export enum Elevator {
  Inside = 'elevator',
  Frame = 'elevator-frame',
  DoorLeft = 'elevator-door-left',
  DoorRight = 'elevator-door-right',
  Toilet = 'toilet-icecream',
}
